export class DrawingToolExtras {

  static blue = '#3bb2d0';
  static orange = '#fbb03b';
  static white = '#fff';

  static styles = [
    // Polygons
    //   Solid fill
    //   Active state defines color
    {
      'id': 'gl-draw-polygon-fill',
      'type': 'fill',
      'filter': [
        'all',
        ['==', '$type', 'Polygon'],
        ['!=', 'meta', 'measure'],
      ],
      'paint': {
        'fill-color': [
          'case',
          ['==', ['get', 'active'], 'true'], this.orange,
          this.blue,
        ],
        'fill-opacity': 0.1,
      },
    },
    // Lines
    // Polygon
    //   Matches Lines AND Polygons
    //   Active state defines color
    {
      'id': 'gl-draw-lines',
      'type': 'line',
      'filter': [
        'any',
        ['all', ['==', '$type', 'LineString'], ['!=', 'meta', 'measure']],
        ['all', ['==', '$type', 'Polygon'], ['!=', 'meta', 'measure']]
      ],
      'layout': {
        'line-cap': 'round',
        'line-join': 'round',
      },
      'paint': {
        'line-color': [
          'case',
          ['==', ['get', 'active'], 'true'], this.orange,
          this.blue,
        ],
        'line-width': 2,
      },
    },
    // Points
    //   Circle with an outline
    //   Active state defines size and color
    {
      'id': 'gl-draw-point-outer',
      'type': 'circle',
      'filter': [
        'all',
        ['==', '$type', 'Point'],
        ['==', 'meta', 'feature'],
      ],
      'paint': {
        'circle-radius': [
          'case',
          ['==', ['get', 'active'], 'true'], 7,
          5,
        ],
        'circle-color': this.white,
      },
    },
    {
      'id': 'gl-draw-point-inner',
      'type': 'circle',
      'filter': [
        'all',
        ['==', '$type', 'Point'],
        ['==', 'meta', 'feature'],
      ],
      'paint': {
        'circle-radius': [
          'case',
          ['==', ['get', 'active'], 'true'], 5,
          3,
        ],
        'circle-color': [
          'case',
          ['==', ['get', 'active'], 'true'], this.orange,
          this.blue,
        ],
      },
    },
    // Vertex
    //   Visible when editing polygons and lines
    //   Similar behaviour to Points
    //   Active state defines size
    {
      'id': 'gl-draw-vertex-outer',
      'type': 'circle',
      'filter': [
        'all',
        ['==', '$type', 'Point'],
        ['==', 'meta', 'vertex'],
        ['!=', 'mode', 'simple_select'],
      ],
      'paint': {
        'circle-radius': [
          'case',
          ['==', ['get', 'active'], 'true'], 7,
          5,
        ],
        'circle-color': this.white,
      },
    },
    {
      'id': 'gl-draw-vertex-inner',
      'type': 'circle',
      'filter': [
        'all',
        ['==', '$type', 'Point'],
        ['==', 'meta', 'vertex'],
        ['!=', 'mode', 'simple_select'],
      ],
      'paint': {
        'circle-radius': [
          'case',
          ['==', ['get', 'active'], 'true'], 5,
          3,
        ],
        'circle-color': this.orange,
      },
    },
    // Midpoint
    //   Visible when editing polygons and lines
    //   Tapping or dragging them adds a new vertex to the feature
    {
      'id': 'gl-draw-midpoint',
      'type': 'circle',
      'filter': [
        'all',
        ['==', 'meta', 'midpoint'],
      ],
      'paint': {
        'circle-radius': 3,
        'circle-color': this.white,
      },
    },
    {
      'id': 'gl-draw-measure-segment',
      'type': 'symbol',
      'filter': ['all', ['==', 'meta', 'measure']],
      'paint': {
        'text-halo-color': "#fffd",
        'text-halo-width': 1.5,
        'text-halo-blur': 0,
      },
      'layout': {
        "text-field": ["concat", ["get", "length"], ["concat", "\n", ["get", "area"]]],
        "text-font": ["Noto Sans Regular"],
        "symbol-placement": "line-center",
        "text-anchor": "bottom",
      }
    },
    {
      'id': 'gl-draw-measure-point',
      'type': 'symbol',
      'filter': ['all', ['==', '$type', 'Point'], ['==', 'meta', 'measure']],
      'paint': {
        'text-halo-color': "#fffd",
        'text-halo-width': 1.5,
        'text-halo-blur': 0,
      },
      'layout': {
        "text-field": ["concat", ["get", "length"], ["concat", "\n", ["get", "area"]]],
        "text-font": ["Noto Sans Regular"]
      }
    }
  ];
  // Copied from mapbox-gl-draw, with few modifications
}
